import { render, staticRenderFns } from "./PageEditorSectionContainerMenu.vue?vue&type=template&id=292fff37&scoped=true"
import script from "./PageEditorSectionContainerMenu.vue?vue&type=script&lang=js"
export * from "./PageEditorSectionContainerMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292fff37",
  null
  
)

export default component.exports